/** @jsxImportSource @emotion/react */
import React from "react";

import { useSurfaceRipple } from "components/hooks/useSurfaceRipple";
import { Interpolation } from "@emotion/react";
import { Theme } from "@emotion/react";

interface ReportsListItemButtonProps {
  text: string;
  count?: number;
  onClick?: () => void;
  css?: Interpolation<Theme>;
  isActive?: boolean;
}

export const ReportsListItemButton: React.FC<ReportsListItemButtonProps> = ({
  text,
  count,
  onClick,
  css: cssOverride,
  isActive = false,
}) => {
  const { rippleContainerRef, createRipple, rippleStyles } =
    useSurfaceRipple<HTMLButtonElement>();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    createRipple(e);
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      ref={rippleContainerRef}
      onClick={handleClick}
      css={[
        {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          padding: "12px 16px",
          minHeight: 48,
          background: isActive ? "#fafafa" : "#fff",
          border: "none",
          borderRadius: 0,
          cursor: "pointer",
          fontSize: 16,
          position: "relative",
        },
        cssOverride,
      ]}
    >
      {isActive && (
        <span
          css={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: 6,
            background: "#73bcc8",
          }}
        />
      )}
      <span>{text.length > 30 ? text.slice(0, 30) + "…" : text}</span>
      {count !== undefined ? (
        <span
          css={{
            background: "#e0e0e0",
            borderRadius: 12,
            padding: "2px 8px",
            fontSize: 14,
            marginLeft: 8,
          }}
        >
          {count}
        </span>
      ) : null}
      <span css={rippleStyles} />
    </button>
  );
};
